export default class {
  constructor(item = {}) {
    this.id = item.id || null;
    this.coordinates = {
      x: item.x,
      y: item.y
    };
    this.value = item.value;
  }
}
